import React from 'react';
import { motion } from 'framer-motion';
import { Star, Plus, Clock } from 'lucide-react';
import { useTemplateStore } from '../../store/templateStore';
import { useMealStore } from '../../store/mealStore';

interface MealTemplateListProps {
  mealType: string;
}

export function MealTemplateList({ mealType }: MealTemplateListProps) {
  const { templates } = useTemplateStore();
  const { addMeal } = useMealStore();

  const typeTemplates = templates.filter(t => t.type === mealType);

  const handleUseTemplate = (template: any) => {
    addMeal({
      type: mealType,
      time: new Date().toISOString(),
      foods: template.foods
    });
  };

  if (typeTemplates.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="theme-card p-6 space-y-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Star className="w-5 h-5 text-primary" />
          <h3 className="font-medium">Quick Add</h3>
        </div>
        <div className="text-sm text-muted-foreground">
          {typeTemplates.length} templates
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {typeTemplates.map((template) => (
          <motion.button
            key={template.id}
            onClick={() => handleUseTemplate(template)}
            className="p-3 bg-muted/30 rounded-lg text-left hover:bg-muted/50 transition-colors relative group"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="font-medium">{template.name}</div>
            <div className="text-sm text-muted-foreground">
              {template.foods.length} items • {Math.round(template.calories)} cal
            </div>
            
            <div className="absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity">
              <Plus className="w-4 h-4 text-primary" />
            </div>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
}